'use client';

import { createContext, type ReactNode, useContext } from 'react';

// True for any subtree rendered inside an auto-drawer (a Popover presented as a
// bottom sheet on mobile). Lets PopoverContent/PopoverItem shed their desktop
// floating-box chrome, and lets a nested Popover know to stack as a 2nd drawer.
const DrawerModeContext = createContext(false);

export const DrawerModeProvider = ({ children }: { children: ReactNode }) => (
	<DrawerModeContext.Provider value={true}>{children}</DrawerModeContext.Provider>
);

/** True when this subtree is rendered inside an auto-drawer. */
export const useInDrawer = () => useContext(DrawerModeContext);
